import { base, baseContainer } from "@base-provider";
import { API_PARAM } from "../constants/apiParams";

export const getNotifications = () => {
  return base.get({
    url: `${API_PARAM.NOTIFICATIONS}`,
    params: {
      moduleName: baseContainer.config.appName,
    },
  });
};

export const getNotificationById = (id) => {
  return base.get({
    url: `${API_PARAM.NOTIFICATIONS}/${id}`,
    params: { id },
  });
};

export const createNotification = (data) => {
  return base.post({
    url: `${API_PARAM.NOTIFICATIONS}`,
    data,
  });
};

export const markNotificationsAsRead = () => {
  return base.patch({
    url: `${API_PARAM.NOTIFICATIONS}`,
    data: {
      moduleName: baseContainer.config.appName,
    },
  });
};

export const dismissNotification = (id) => {
  return base.patch({
    url: `${API_PARAM.NOTIFICATIONS}/${id}`,
  });
};